import React from 'react'

import { Helmet } from '@dr.pogodin/react-helmet'

type HelmetProps = React.ComponentProps<typeof Helmet>

export const Head: React.FC<HelmetProps> = ({
  title,
  titleTemplate = '%s | NeoDXP',
}) => <Helmet title={title} titleTemplate={titleTemplate} />
